import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyMask } from '~/utils/masks';

export const HeaderChangedLimit = [
  {
    id: 1,
    value: 'Nome completo',
    maxChar: 25,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Data da Alteração',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Origem',
    maxChar: 10,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Valor sugerido',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Valor estabelecido',
    maxChar: 15,
    textAlign: 'center',
  },
];

export const BodyChangedLimit = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nomeCliente,
        maxChar: 25,
      },
      {
        value: i.cpf ? cpfMask(i.cpf).masked : '',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dataAumentoLimite
          ? moment(i.dataAumentoLimite).format('DD/MM/YY')
          : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.tipoAumento ? i.tipoAumento : '-',
        maxChar: 10,
        textAlign: 'center',
      },
      {
        value: `R$ ${currencyMask(i.valorSugeridoMotor)}`,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: `R$ ${currencyMask(i.valorEstabelecido)}`,
        maxChar: 15,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
